import { defineNuxtPlugin } from '#app';
import { usePostHog } from '#imports';
import { useMainStore } from '../stores/mainStore.js';

// Adds the current school's org IDs as PostHog super properties so homepage (and all)
// pageviews captured by @posthog/nuxt can be broken down per school. Mirrors the
// parent_org / secondary_org dimensions sent to Google Analytics.
//
// The "00." filename prefix is load-bearing: posthog-js schedules the initial $pageview
// on a setTimeout during init (in the posthog-client module plugin), so this register()
// must run before any plugin that awaits (launch-darkly.client.js awaits its network
// init) yields the event loop — otherwise the pageview is captured without these
// properties. dependsOn still guarantees the PostHog client is initialized first.
export default defineNuxtPlugin({
  name: 'posthog-school-context',
  dependsOn: ['posthog-client'],
  setup() {
    const posthog = usePostHog();
    if (!posthog) {
      return;
    }

    const mainStore = useMainStore();
    posthog.register({
      parent_org: mainStore.parentOrgId,
      secondary_org: mainStore.secondaryOrgId,
      client_domain: window.location.hostname,
    });
  },
});
